// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';

import './permission' // permission control
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({ 
  el: '#app',
  router,
  store,
  components: { App }, 
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js